var React = require('react');

function Respond (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","strokeDasharray":"4,2","d":"M1 28V1h62v62H36","key":0}),React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M1 33h30v30H1z","key":1}),React.createElement("path",{"fill":"none","strokeWidth":"2","strokeLinejoin":"bevel","strokeMiterlimit":"10","d":"M57 18V7H46","key":2}),React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M57 7L41 23","key":3})]);
}

Respond.defaultProps = {"version":"1.0","width":"64","height":"64"};

module.exports = Respond;

Respond.default = Respond;
